/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'

/**
 * Typescript enum
 */

export enum TournamentAccessControl {
  community = 'community',
  private = 'private',
  public = 'public'
}

/**
 * TournamentAccessControl
 *
 * The specific tournament access
 */
export const TournamentAccessControlEnumType = types.enumeration('TournamentAccessControl', [
  'community',
  'private',
  'public'
])
